import { Box, Button } from '@stitch-fix/mode-react';
import classNames from 'classnames';
import { useSelectEvent } from '@stitch-fix/event-reporter';
import { useStickyCtaContext } from './useStickyCtaContext';
import { buttonColorToButtonVariant } from '../ModuleFooter/ModuleFooter';
import styles from './styles.module.scss';
const buttonColorToStickyCtaButtonClassName = (buttonColor?: string) => {
  switch (buttonColor) {
    case 'mint':
      return styles.stickyCtaButtonStatement;
    case 'navy':
      return styles.stickyCtaButtonStaple;
    case 'holiday forest':
      return styles.stickyCtaButtonHolidayForest;
    case 'holiday grapefruit':
      return styles.stickyCtaButtonHolidayGrapefruit;
    case 'holiday snow':
      return styles.stickyCtaButtonHolidaySnow;
    case 'citrus':
    default:
      return styles.stickyCtaButtonAccent;
  }
};
export type StickyCtaProps = {
  cta: {
    title: string;
    href: string;
  };
  buttonColor?: string;
  CtaButton?: never;
} | {
  cta?: never;
  buttonColor?: never;
  CtaButton: React.ReactNode;
};

// The StickyCta component is hidden when the Hero component is in view.
// To use StickyCta, wrap the parent element  of the Hero and the StickyCta in <StickyCtaContextProvider>.

export const StickyCta = ({
  cta,
  buttonColor,
  CtaButton
}: StickyCtaProps) => {
  const {
    isStickyCtaHidden
  } = useStickyCtaContext();
  const {
    reportSelectEvent
  } = useSelectEvent();
  const handleButtonClick = () => {
    if (cta?.href === '/signup') {
      reportSelectEvent({
        action_name: 'navigate_to_signup',
        content_id: 'sticky_cta',
        name: 'take_style_quiz_button',
        schema: 'select'
      });
    }
  };
  return <Box className={classNames(styles.stickyCtaContainer, {
    [styles.hidden]: isStickyCtaHidden,
    [styles.shown]: !isStickyCtaHidden
  })}>
      {cta ? <div className={buttonColorToStickyCtaButtonClassName(buttonColor)}>
          <Button as="a" variant={buttonColorToButtonVariant(buttonColor)} width={{
        sm: 'fill'
      }} href={cta.href} onClick={handleButtonClick}>
            {cta.title}
          </Button>
        </div> : CtaButton}
    </Box>;
};